export default {
  RTP: '96.11%',
  GAME_WIDTH: 2340,
  GAME_HEIGHT: 1080,
}
